module.exports = {
  Server: {
    CREATED_GAME: 'created game',
    UNANSWERED: 'unanswered',
    ANSWERED: 'answered',
    SCORE_UPDATE: 'score update',
    NEW_QUESTION: 'new question',
    GAME_ENDED: 'game ended',
    PLAYER_LEFT: 'player left',
    CHAT: 'chat',
    PLAYER_JOINED: 'player joined',
    NO_SUCH_GAME: 'no such game',
    AVATAR_ASSIGNED: 'avatar assigned',
    ROOM_CLOSED: 'room closed',
    GAMES_LIST: 'games list',
    UNANSWERED_QUESTIONS_LIST: 'unanswered questions list',
  },
  Client: {
    CREATE_GAME: 'create game',
    JOIN_GAME: 'join game',
    SKIP: 'skip',
    CHAT: 'chat',
  },
};
